import type { RaceEventDependencies } from '../raceEvent/RaceEventController';
import type { App } from '../../app/App';
import { ObservableValue } from '../../app/state/createObservableValue';
import { MetaPopupStackController } from '../../metaAbstractions/createMetaPopupController';
import type { ResourceMap } from '../../app/resources/types';
import { isConditionFulfilled } from '../../app/state/events/isEventConditionFulfilled';
import type { RaceEventState } from '../raceEvent/types';

export function createRaceEventDependencies(app: App): RaceEventDependencies {
  return {
    currentUser: app.platform.getCurrentPlayer(),
    observable: new ObservableValue(app.stateController, ['levelIndex', 'raceEvent', 'raceEventLastEndTime']),
    popupsController: new MetaPopupStackController(app.controller.popups),
    shareImage: app.platform.shareable
      ? async (imageBase64: Promise<string>): Promise<void> => {
          await app.platform.shareable?.share?.(await imageBase64);
        }
      : null,
    addResources(resourceMap: ResourceMap, eventId: string): void {
      app.resources.addRaceEventReward(resourceMap, eventId);
    },
    isConditionMet: (condition): boolean => isConditionFulfilled(app.stateController, condition),
    tracking: {
      onFirstInstancePopupOpened(): void {
        app.platform.logEvent(`Race_Event_Seen`);
      },
      onEventStarted(eventId: string): void {
        app.platform.logEvent(`Race_Event_Joined`);
        app.tracking.trackEventStarted('Race', eventId);
      },
      onEventFinished(state: RaceEventState, finishedRank: number): void {
        app.tracking.trackEventFinished({
          eventId: state.id,
          progress: state.currentProgress,
          type: 'Race',
          rank: finishedRank,
          metaProperties: [
            {
              metaPropertyValue: `${state.currentProgress}`,
              metaPropertyName: 'raceLevel',
            },
          ],
        });
      },
    },
  };
}
